export class QueryParamsFactory {
    createQueryParams(query) {
        const params = new URLSearchParams();
        params.set('offset', `${query.offset}`);
        params.set('limit', `${query.limit}`);
        const { filters } = query;
        for (let i = 0; i < filters.length; i++) {
            params.set(`filters[${i}][name]`, filters[i].name);
            params.set(`filters[${i}][value]`, filters[i].values.join('|'));
            params.set(`filters[${i}][op]`, filters[i].op);
        }
        return params;
    }
}
